import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22Manrope%22,%22arguments%22:[{%22variable%22:%22--font-manrope%22,%22subsets%22:[%22latin%22,%22vietnamese%22]}],%22variableName%22:%22getManrope%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Manrope', 'Manrope Fallback'",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
